import { useEffect, useState, useCallback } from 'react';
import websocketService from '../utils/websocketService';

export const useWebSocket = (topic) => {
  const [connected, setConnected] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let subscription = null;

    const connectAndSubscribe = () => {
      if (!websocketService.isConnected()) {
        websocketService.connect(
          () => {
            setConnected(true);
            setError(null);
            // Subscribe to topic after connection
            if (topic) {
              subscription = websocketService.subscribe(topic, (message) => {
                setLastMessage(message);
              });
            }
          },
          (err) => {
            setConnected(false);
            setError(err);
            console.error('WebSocket connection error:', err);
          }
        );
      } else {
        // Already connected, just subscribe
        setConnected(true);
        if (topic) {
          subscription = websocketService.subscribe(topic, (message) => {
            setLastMessage(message);
          });
        }
      }
    };

    connectAndSubscribe();

    // Cleanup
    return () => {
      if (topic) {
        websocketService.unsubscribe(topic);
      }
    };
  }, [topic]);

  const disconnect = useCallback(() => {
    websocketService.disconnect();
    setConnected(false);
  }, []);

  return {
    connected,
    lastMessage,
    error,
    disconnect
  };
};